import { render, staticRenderFns } from "./StreamingChartsTrend.vue?vue&type=template&id=5fa077b0&scoped=true"
import script from "./StreamingChartsTrend.vue?vue&type=script&setup=true&lang=ts"
export * from "./StreamingChartsTrend.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StreamingChartsTrend.vue?vue&type=style&index=0&id=5fa077b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa077b0",
  null
  
)

export default component.exports